import { apiClient } from "api";
import { TVoiceFileExtensions } from "./models/types";

export const getVoiceFileExtensions = async (): Promise<TVoiceFileExtensions[]> => {
  return apiClient.get("VoiceFileExtensions").then(response => response.data);
};
